import { render, staticRenderFns } from "./InstancesPopup.vue?vue&type=template&id=c4a28b5a&scoped=true"
import script from "./InstancesPopup.vue?vue&type=script&lang=js"
export * from "./InstancesPopup.vue?vue&type=script&lang=js"
import style0 from "./InstancesPopup.vue?vue&type=style&index=0&id=c4a28b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a28b5a",
  null
  
)

export default component.exports